/* ESPEJOL · Home */
(function(){
  if(window.__ehInit) return; window.__ehInit = true;
  window.EH_READY = true;
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  var saveData = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  var hasIO = 'IntersectionObserver' in window;

  /* Aparicion */
  function initReveal(root){
    var els = (root || document).querySelectorAll('[data-eh-reveal]:not(.is-in)');
    if(!hasIO || reduce){ els.forEach(function(el){ el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function(el){ io.observe(el); });
  }

  /* Texto que se ilumina al hacer scroll */
  function initWords(root){
    (root || document).querySelectorAll('[data-eh-words]').forEach(function(el){
      if(el.__eh) return; el.__eh = true;
      var walk = function(node){
        Array.prototype.slice.call(node.childNodes).forEach(function(n){
          if(n.nodeType === 3){
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function(part){
              if(!part) return;
              if(/^\s+$/.test(part)){ frag.appendChild(document.createTextNode(part)); return; }
              var s = document.createElement('span'); s.className = 'w'; s.textContent = part; frag.appendChild(s);
            });
            n.parentNode.replaceChild(frag, n);
          } else if(n.nodeType === 1){ walk(n); }
        });
      };
      walk(el);
      var words = el.querySelectorAll('.w');
      if(reduce){ words.forEach(function(w){ w.classList.add('is-lit'); }); return; }
      var ticking = false;
      var update = function(){
        ticking = false;
        var r = el.getBoundingClientRect(), vh = window.innerHeight;
        var start = vh * 0.88, end = vh * 0.42;
        var p = (start - r.top) / ((start - end) + r.height * 0.6);
        p = Math.max(0, Math.min(1, p));
        var lit = Math.round(p * words.length);
        for(var i = 0; i < words.length; i++){ words[i].classList.toggle('is-lit', i < lit); }
      };
      var onScroll = function(){ if(!ticking){ ticking = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  }

  /* Video: solo se carga cuando conviene */
  function pickSrc(v){
    var mq = v.getAttribute('data-eh-media');
    if(mq && !window.matchMedia(mq).matches) return '';
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    return (mobile ? (v.getAttribute('data-src-m') || '') : (v.getAttribute('data-src-d') || '')) || '';
  }
  function startVideo(v){
    if(v.__ehStarted) return;
    var src = pickSrc(v);
    if(!src) return;
    v.__ehStarted = true;
    v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
    v.src = src;
    var shown = function(){ v.classList.add('is-playing'); };
    v.addEventListener('playing', shown, { once: true });
    var p = v.play(); if(p && p.catch){ p.catch(function(){ v.__ehBlocked = true; }); }
  }
  function initVideos(root){
    var vids = (root || document).querySelectorAll('video[data-eh-video]');
    if(!vids.length || reduce || saveData) return;
    vids.forEach(function(v){
      if(v.__ehObs) return; v.__ehObs = true;
      if(!hasIO){ startVideo(v); return; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            if(!v.__ehStarted){ startVideo(v); }
            else if(!v.__ehUserPaused && v.paused){ var p = v.play(); if(p && p.catch) p.catch(function(){}); }
          } else if(v.__ehStarted && !v.paused){ v.pause(); }
        });
      }, { rootMargin: '200px 0px', threshold: 0.01 });
      io.observe(v);
    });
  }

  /* Portada */
  function initHero(root){
    (root || document).querySelectorAll('[data-eh-hero]').forEach(function(hero){
      var setTop = function(){
        var top = hero.getBoundingClientRect().top + window.pageYOffset;
        hero.style.setProperty('--eh-top', Math.max(0, Math.round(top)) + 'px');
      };
      setTop(); window.addEventListener('load', setTop);
      var v = hero.querySelector('video'), btn = hero.querySelector('.eh-hero__toggle');
      if(!v || !btn) return;
      if(reduce || saveData || !pickSrc(v)){ btn.hidden = true; return; }
      btn.hidden = false;
      btn.addEventListener('click', function(){
        if(v.paused){ v.__ehUserPaused = false; if(!v.__ehStarted){ startVideo(v); } else { v.play(); } btn.classList.remove('is-paused'); btn.setAttribute('aria-label', btn.getAttribute('data-pause')); }
        else { v.__ehUserPaused = true; v.pause(); btn.classList.add('is-paused'); btn.setAttribute('aria-label', btn.getAttribute('data-play')); }
      });
    });
  }

  /* CONVETI: acercamiento suave */
  function initConveti(root){
    (root || document).querySelectorAll('.eh-conveti').forEach(function(sec){
      if(!hasIO || reduce){ sec.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function(entries){ entries.forEach(function(e){ if(e.isIntersecting){ sec.classList.add('is-in'); io.disconnect(); } }); }, { threshold: 0.2 });
      io.observe(sec);
    });
  }

  /* Conversion de WhatsApp */
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('[data-eh-wa]');
    if(a && typeof window.gtag === 'function'){
      try{ window.gtag('event', 'conversion', { send_to: 'AW-16897459775/MaqYCIH_qLAaEL-Mq_k-' }); }catch(err){}
    }
  });

  function init(root){ initHero(root); initReveal(root); initWords(root); initVideos(root); initConveti(root); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
